import React from "react";

import { SUBTITLES_BACKGROUND_OPTIONS } from "../../constants";
import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n, { TranslationKey } from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { MenuHeader } from "../settings/MenuHeader";
import {
  Divider,
  InputLabel,
  SettingInput,
  SettingMenu,
  SettingOption
} from "../settings/styles";
import { TopLevelSettingOption } from "../settings/TopLevelSettings";

type OptionsProps = {
  onClickBack: () => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const SubtitlesBackgroundOptions = ({
  onBlur,
  onClickBack
}: OptionsProps) => {
  const { useStoreState } = usePlayerStore();
  const subtitlesBackground = useStoreState.subtitlesBackground();
  const uiSize = useStoreState.uiSize();

  const setSubtitlesBackground = useStoreState.setSubtitlesBackground();

  const { language } = useEmbedParametersContext();

  return (
    <>
      <MenuHeader
        backToTopLevel={onClickBack}
        label="tekstityksien_taustavari"
      />
      <Divider />
      <SettingMenu role="menu">
        {SUBTITLES_BACKGROUND_OPTIONS.map(item => (
          <SettingOption key={item}>
            <SettingInput
              checked={subtitlesBackground === item}
              id={`subtitles-background-setting-${item}`}
              name="subtitles-background"
              onBlur={onBlur}
              onChange={() => setSubtitlesBackground(item, true)}
              onClick={onClickBack}
            />
            <InputLabel
              htmlFor={`subtitles-background-setting-${item}`}
              uiSize={uiSize}>
              {i18n(("tekstityksien_taustavari_" + item) as TranslationKey, {
                language
              })}
            </InputLabel>
          </SettingOption>
        ))}
      </SettingMenu>
    </>
  );
};

type TopLevelOptionProps = {
  onBlur: (event) => void;
  onClick: () => void;
};
export const SubtitlesBackgroundTopLevelOption = ({
  onBlur,
  onClick
}: TopLevelOptionProps) => {
  const { useStoreState } = usePlayerStore();
  const subtitlesBackground = useStoreState.subtitlesBackground();
  const { language } = useEmbedParametersContext();

  return (
    <TopLevelSettingOption
      onBlur={onBlur}
      onClick={onClick}
      title={i18n("tekstityksien_taustavari", { language })}
      value={i18n(`tekstityksien_taustavari_${subtitlesBackground}`, {
        language
      })}
    />
  );
};
